import gsap from "gsap";

export const cursor = () => {
    gsap.matchMedia().add(
        "(min-width: 900px)", () => {
            gsap.set(".cursor", {xPercent: -50, yPercent: -50});

            const cursor = document.querySelector(".cursor");
            const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
            const mouse = { x: pos.x, y: pos.y };
            const speed = 0.15;
        
            const xSet = gsap.quickSetter(cursor, "x", "px");
            const ySet = gsap.quickSetter(cursor, "y", "px");
        
            window.addEventListener("mousemove", e => {    
            mouse.x = e.x;
            mouse.y = e.y;  
            });
        
            gsap.ticker.add(() => {
            
                // adjust speed for higher refresh monitors
                const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio()); 
                
                pos.x += (mouse.x - pos.x) * dt;
                pos.y += (mouse.y - pos.y) * dt;
                xSet(pos.x);
                ySet(pos.y);
            });
        },
    )
}

export const cursorHover = () => {
    const video = document.querySelectorAll('.video__module-btn');
    const contactOverlay = document.querySelector('.contact-modal__row');
    const footer = document.querySelector('.theme-footer');
    const cursor = document.querySelector('.cursor');
    const swiperNext = document.querySelectorAll('.swiper-button--next');
    const swiperPrev = document.querySelectorAll('.swiper-button--prev');

    // contactOverlay.addEventListener('mouseenter', () => {
    //     cursor.classList.add('cursor--color-invert');
    // })

    // contactOverlay.addEventListener('mouseleave', () => {
    //     cursor.classList.remove('cursor--color-invert');
    // })

    swiperNext.forEach(e => {
        e.addEventListener('mouseover', () => {
            cursor.classList.add('cursor--next');
            cursor.classList.add('cursor--img');
        })
        e.addEventListener('mouseout', () => {
            cursor.classList.remove('cursor--next');
            cursor.classList.remove('cursor--img');
        })
    })

    swiperPrev.forEach(e => {
        e.addEventListener('mouseover', () => {
            cursor.classList.add('cursor--prev');
            cursor.classList.add('cursor--img');
        })
        e.addEventListener('mouseout', () => {
            cursor.classList.remove('cursor--prev');
            cursor.classList.remove('cursor--img');
        })
    })

    video.forEach(e => {
        e.addEventListener('mouseenter', () => {
            cursor.classList.add('cursor--video');
            cursor.classList.add('cursor--img');
        })
        e.addEventListener('mouseleave', () => {
            cursor.classList.remove('cursor--video');
            cursor.classList.remove('cursor--img');
        })
    })

    // footer?.addEventListener('mouseenter', () => {
    //     !footer.classList.contains('theme-footer--no-links') ? cursor.classList.add('cursor--color-invert') : '';
    // })

    // if (!!footer) {    
    //     footer.addEventListener('mouseleave', () => {
    //         !footer.classList.contains('theme-footer--no-links') ? cursor.classList.remove('cursor--color-invert') : '';
    //     })
    // }
}